<template>
  <div id="location-shows">
    <BaseArchiveTemplate>
      <template v-if="shows.length" #grid>
        <ShowCard
          v-for="(show, index) in shows"
          :key="`show-${show.id}-${index}`"
          :show-data="show"
        />
        <div class="show-card" />
        <div class="show-card" />
        <div class="show-card" />
      </template>
      <template v-if="shows.length" #loader>
        <Loading v-if="loading" color="black" />
      </template>
      <template v-if="pageHasContent" #not-found>
        <NotFoundFlag :msg="getRouteName" />
      </template>
    </BaseArchiveTemplate>
    <template v-if="shows.length">
      <IntersectionObserver
        v-if="!loading && !noMoreDataToLoad"
        :init-observer="initObserver"
        @intersect="loadMore"
      />
    </template>
  </div>
</template>
<script>
import axios from 'axios';
import BaseArchiveTemplate from '@/components/BaseArchiveTemplate.vue';
import IntersectionObserver from '@/components/ui/IntersectionObserver.vue';
import ShowCard from '@/components/cards/ShowCard.vue';
import Loading from '@/components/ui/Loading.vue';
import NotFoundFlag from "@/components/errorHandlers/NotFoundFlag";
export default {
  name: 'LocationShows',
  components: {
    IntersectionObserver,
    ShowCard,
    Loading,
    BaseArchiveTemplate,
    NotFoundFlag
  },
  data: () => ({
    shows: [],
    page: 0,
    pageSize: 12,
    totalPages: null,
    initObserver: false,
    loading: true
  }),
  computed: {
    noMoreDataToLoad() {
      return this.page === this.totalPages - 1;
    },
    pageHasContent() {
      return this.shows.length === 0 && this.loading === false;
    },
    getRouteName() {
      return this.$route.name.split('-').pop();
    }
  },
  mounted() {
    this.loadMore();
    this.$nextTick(() => {
      this.initObserver = true;
    });
  },
  methods: {
    loadMore() {
      this.loading = true;
      this.shows.length ? this.page++ : (this.page = 0);
      this.getShowsByLocation()
    },
    getShowsByLocation() {
      axios
          .get(
              this.$router.options.api +
              `/podcasts/paged-podcasts-active-location/${this.$route.params.id}?page=${this.page}&size=${this.pageSize}`
          )
          .then(response => {
            this.totalPages = response.data.totalPages;
            this.shows = [...this.shows, ...response.data.content];
            this.loading = false;
          })
          .catch(error => console.error(error));
    }
  }
};
</script>
